import { isInPage } from 'utils/isInPage';

const scrollToBlock = (elementId) => {
  if (isInPage(document.getElementById(elementId))) {
    document.getElementById(elementId).scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
};

export { scrollToBlock };
